import { LoadingSpinner, Stack } from '@adc/parallax-component-library';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { authState } from '~/features/auth/state';
import { getIndexNavigationPathByRole } from '~/features/navigation/utils';
import { protectedRoute } from '~/utils/routesAuthorization';

export const Route = createFileRoute('/')({
  component: RouteComponent,
  beforeLoad: () => {
    protectedRoute();

    // Get default navigation item
    const { userInfo } = authState.get();

    // Redirect based on role
    throw redirect({
      to: getIndexNavigationPathByRole(userInfo?.role) ?? '/support',
      replace: true,
      // Keep search params
      search: (old) => ({ ...old }),
    });
  },
});

function RouteComponent() {
  return (
    <Stack flex={1} justifyContent="center" alignItems="center">
      <LoadingSpinner />
    </Stack>
  );
}
